module.exports = __webpack_public_path__ + "img/nature-vs-humans.a1ba3223.jpg";